// extracted by mini-css-extract-plugin
export const featuredTrainers = "featured-trainers-module--featured-trainers--2wfNF";
export const reversedRow = "featured-trainers-module--reversed-row--18x88";
export const trainerName = "featured-trainers-module--trainer-name--1j4Kx";
export const bio = "featured-trainers-module--bio--dsUgz";
export const seeAllButton = "featured-trainers-module--see-all-button--13_bc";
export const mobileInstructorRow = "featured-trainers-module--mobile-instructor-row--37Ixh";